import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import { ErrorMessage, Field } from "formik";

interface DateTimeFieldsProps {
  errors: any;
  touched: any;
  values: any;
  setFieldValue: (field: string, value: any) => void;
  showStartDate?: boolean;
  showStartTime?: boolean;
  showEndDate?: boolean;
  showEndTime?: boolean;
  showAllDay?: boolean;
  startDateName?: string;
  startTimeName?: string;
  endDateName?: string;
  endTimeName?: string;
  allDayName?: string;
  startDateLabel?: string;
  startTimeLabel?: string;
  endDateLabel?: string;
  endTimeLabel?: string;
  allDayLabel?: string;
}

export const DateTimeFields: React.FC<DateTimeFieldsProps> = ({
  errors,
  touched,
  values,
  setFieldValue,
  showStartDate = true,
  showStartTime = true,
  showEndDate = true,
  showEndTime = true,
  showAllDay = true,
  startDateName = "startDate",
  startTimeName = "startTime",
  endDateName = "endDate",
  endTimeName = "endTime",
  allDayName = "isAllDay",
  startDateLabel = "Start Date",
  startTimeLabel = "Start Time",
  endDateLabel = "End Date",
  endTimeLabel = "End Time",
  allDayLabel = "All Day"
}) => {
  return (
    <>
      {showStartDate && (
        <Form.Group as={Row} className="mb-3" controlId={startDateName}>
          <Form.Label column sm={3}>
            {startDateLabel} <span style={{ color: 'red' }}>*</span>
          </Form.Label>
          <Col sm={9}>
            <Field
              name={startDateName}
              type="date"
              className={
                "form-control" +
                (errors[startDateName] && touched[startDateName] ? " is-invalid" : "")
              }
            />
            <ErrorMessage
              name={startDateName}
              component="div"
              className="invalid-feedback"
            />
          </Col>
        </Form.Group>
      )}

      {showStartTime && !values[allDayName] && (
        <Form.Group as={Row} className="mb-3" controlId={startTimeName}>
          <Form.Label column sm={3}>
            {startTimeLabel} <span style={{ color: 'red' }}>*</span>
          </Form.Label>
          <Col sm={9}>
            <Field
              name={startTimeName}
              type="time"
              className={
                "form-control" +
                (errors[startTimeName] && touched[startTimeName] ? " is-invalid" : "")
              }
            />
            <ErrorMessage
              name={startTimeName}
              component="div"
              className="invalid-feedback"
            />
          </Col>
        </Form.Group>
      )}

      {showEndDate && (
        <Form.Group as={Row} className="mb-3" controlId={endDateName}>
          <Form.Label column sm={3}>
            {endDateLabel} <span style={{ color: 'red' }}>*</span>
          </Form.Label>
          <Col sm={9}>
            <Field
              name={endDateName}
              type="date"
              className={
                "form-control" +
                (errors[endDateName] && touched[endDateName] ? " is-invalid" : "")
              }
            />
            <ErrorMessage
              name={endDateName}
              component="div"
              className="invalid-feedback"
            />
          </Col>
        </Form.Group>
      )}

      {showEndTime && !values[allDayName] && (
        <Form.Group as={Row} className="mb-3" controlId={endTimeName}>
          <Form.Label column sm={3}>
            {endTimeLabel} <span style={{ color: 'red' }}>*</span>
          </Form.Label>
          <Col sm={9}>
            <Field
              name={endTimeName}
              type="time"
              step="1800"
              className={
                "form-control" +
                (errors[endTimeName] && touched[endTimeName] ? " is-invalid" : "")
              }
            />
            <ErrorMessage
              name={endTimeName}
              component="div"
              className="invalid-feedback"
            />
          </Col>
        </Form.Group>
      )}

      {showAllDay && (
        <Form.Group as={Row} className="mb-3" controlId={allDayName}>
          <Form.Label column sm={3}>
            {allDayLabel}
          </Form.Label>
          <Col sm={9}>
            <Form.Check
              type="checkbox"
              checked={values[allDayName]}
              onChange={(e) => setFieldValue(allDayName, e.target.checked)}
              label="This event is all day"
            />
          </Col>
        </Form.Group>
      )}
    </>
  );
};
